<template>
  <div
    class="d-flex flex-column align-start justify-start tree-item"
    :class="[leftPadding, !isChild ? 'pr-1' : '']"
  >
    <div
      class="d-flex align-center justify-start tree-item-action pl-2"
      @click="selectedModel = !selectedModel"
    >
      <v-icon
        v-if="option.children?.length"
        :icon="isOpen ? '$menu-down' : '$menu-right'"
        @click.stop="isOpen = !isOpen"
      />
      <DpplSimpleCheckbox
        v-model="selectedModel"
        :option="option"
        @click.stop
      >
        <template #option-label="{ option: slotOption }">
          <slot
            name="option-label"
            :option="slotOption"
          />
        </template>
      </DpplSimpleCheckbox>
    </div>
    <TreeItemChildren
      v-if="option.children?.length && isOpen"
      :option="option"
      :selected="selected"
      :id-key="idKey"
      :level-has-children="anyHaveChildren"
      @update:model-value="$emit('update:modelValue', $event)"
    />
  </div>
</template>

<script setup>
import DpplSimpleCheckbox from '@/components/datapeople/DpplSimpleCheckbox.vue';
import { computed, ref, defineAsyncComponent } from 'vue';

const TreeItemChildren = defineAsyncComponent(() => import('@/components/shared/TreeItemChildren.vue'));

const props = defineProps({
  option: {
    type: Object,
    default: () => ({}),
  },
  selected: {
    type: Array,
    default: () => ([]),
  },
  isChild: {
    type: Boolean,
    default: false,
  },
  levelHasChildren: {
    type: Boolean,
    default: false,
  },
  idKey: {
    type: String,
    default: 'id',
  },
});

const emits = defineEmits(['update:modelValue']);

// State
const isOpen = ref(false);

// Computed
const selectedModel = computed({
  get: () => props.selected.some(({ [props.idKey]: id }) => id === props.option[props.idKey]),
  set: (value) => {
    if (value) {
      emits('update:modelValue', [...props.selected, props.option]);
    } else {
      emits('update:modelValue', props.selected.filter(({ [props.idKey]: id }) => id !== props.option[props.idKey]));
    }
  },
});

const leftPadding = computed(() => {
  if (!props.isChild && props.levelHasChildren && !props.option.children?.length) return 'pl-7';
  if (!props.isChild && !props.levelHasChildren) return 'pl-0';
  if (props.option.children?.length) return 'pl-1';
  return 'pl-6';
});

const anyHaveChildren = computed(() => (props.option.children || [])
  .some((option) => option.children?.length));

</script>

<style scoped lang="less">
.tree-item {
  width: 100%;
}

.tree-item-action {
  min-width: 100%;
  min-height: 32px;

  &:hover {
    background: rgba(@bg-brand-default, .05);
  }
}

:deep(label) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.children {
  width: 100%;
}
</style>
